<template>
  <div class="page-home">
    <div class="g-wrap news-wrap">
      <div class="news">
        <column-header2 :data="newsColumn"></column-header2>
        <div class="column-wrap">
          <ic-slide-news :data="slideNews"></ic-slide-news>
          <ic-news :data="topNews"></ic-news>
        </div>
      </div>
      <div class="industry">
        <column-header2 :data="industryColumn"></column-header2>
        <div class="column-wrap">
          <ic-news :data="industryNews" type="calendar"></ic-news>
        </div>
      </div>
    </div>
    <div class="form-wrap">
      <div class="g-wrap">
        <column-header2 :data="{ name: '在线报名' }"></column-header2>
        <div class="content">
          <span class="stat">
            报名人数：
            <strong>1356</strong>
          </span>
          <el-form ref="form" :model="form" label-width="130px" :rules="rules">
            <div class="form-row">
              <el-form-item prop="collegeName" label="报读院校：">
                <el-select v-model="form.collegeName" :disabled="true" placeholder="请选择" @change="getCollegeLabel">
                  <el-option v-for="item in collegeList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="major" label="报读专业：">
                <el-select v-model="form.major" placeholder="请选择" @change="getMajorLabel">
                  <el-option v-for="item in majorList" :key="item.Id" :label="item.BaseMajor" :value="item.Id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item prop="realName" label="姓名：">
                <el-input v-model="form.realName" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item prop="nativePlace" label="户籍：">
                <el-input v-model="form.nativePlace" placeholder="请输入户籍"></el-input>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item prop="phone" label="联系电话：">
                <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
              <el-form-item prop="address" label="家庭住址：">
                <el-input v-model="form.address" placeholder="请输入家庭住址"></el-input>
              </el-form-item>
            </div>
            <el-form-item prop="graduatedSchool" label="毕业院校：">
              <el-input v-model="form.graduatedSchool" placeholder="请输入毕业院校"></el-input>
            </el-form-item>
            <el-form-item prop="graduatedCertificate" label="毕业证书：">
              <el-upload class="upload" :before-upload="beforeAvatarUpload" :file-list="diplomaFileList" :headers="headers" :action="url" multiple :on-success="handleSuccess" :auto-upload="true" :limit="1">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">
                  （说明：请提供扫描件，图片支持JPG、JPEG、PNG；单张照片不超过5M）
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item prop="IDCard" label="身份证：">
              <el-upload class="upload" :before-upload="beforeAvatarUpload" :file-list="icCardFileList" :headers="headers" :action="url" multiple :on-success="handleSuccess" :auto-upload="true" :limit="2">
                <el-button size="small" type="primary">选择文件</el-button>
                <div slot="tip" class="el-upload__tip">
                  （说明：请提供身份证正反面一起扫描件，图片支持JPG、JPEG、PNG；单张照片不超过5M）
                </div>
              </el-upload>
            </el-form-item>
            <div class="btn-wrap">
              <el-button type="primary" @click="onSubmit" round :loading="loading">提交</el-button>
              <el-button class="btn-reset" @click="onReset" round>重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title :visible.sync="showModal" width="785px" class="dialog" center :show-close="false" :modal="false">
      <i class="icon el-icon-success"></i>
      <div class="text">报名成功</div>
      <div class="desc">
        您好{{ form.realName }}，您报读的
        <strong>{{ realCollegeName }} , {{ realMajor }}</strong>
        已报名成功，请保持电话畅通，我们老师将会与你联系！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="finishClick" round>好滴，知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAllList, createEntity } from "@/api/content-data";
import { uploadImg } from "api/file";
import { getData } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
import SlideNews from "_c/SlideNews";
import { mapState } from "vuex";
import News from "_c/News";
export default {
  name: "panel-admission",
  data() {
    return {
      newsColumn: {
        name: "招生计划",
        link: this.$subsitePrefix + "/ah/admission/list/SchoolRecruitmentPlan"
      },
      industryColumn: {
        name: "通知公告",
        link: this.$subsitePrefix + "/ah/admission/list/SchoolAdmissionInfo"
      },
      slideNews: [],
      topNews: [],
      industryNews: [],
      params: [],
      form: {
        collegeName: "",
        graduatedSchool: "",
        realName: "",
        nativePlace: "",
        validCode: "",
        userName: "",
        phone: "",
        address: "",
        graduatedCertificate: "",
        IDCard: ""
      },
      loading: false,
      showModal: false,
      headers: { Authorization: "Bearer " + this.$store.getters.token },
      url: process.env.VUE_APP_BASE_API + "/BO/FileManage/UploadSingleFile",
      diplomaFileList: [],
      icCardFileList: [],
      collegeList: [],
      majorList: [],
      realCollegeName: "",
      realMajor: "",
      rules: {
        collegeName: [
          { required: true, message: "请输入院校名称", trigger: "blur" }
        ],
        major: [{ required: true, message: "请选择专业", trigger: "blur" }],
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        nativePlace: [
          { required: true, message: "请输入籍贯", trigger: "blur" }
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
      }
    };
  },
  components: {
    [ColumnHeader.name]: ColumnHeader,
    [SlideNews.name]: SlideNews,
    [News.name]: News
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  methods: {
    loadSlideNews() {
      let queryParam = Object.assign([], this.params);
      queryParam.push({
        Key: "Illustration",
        Value: "",
        CompareType: "NotEqualTo"
      });
      getData({
        name: "SchoolRecruitmentPlan",
        top: 5,
        params: queryParam
      }).then(res => {
        this.slideNews = (res || []).map(item => {
          item.link =
            this.$subsitePrefix +
            `/ah/admission/detail/SchoolRecruitmentPlan?id=${item.Id}`;
          return item;
        });
      });
    },
    loadTopNews() {
      getData({
        name: "SchoolRecruitmentPlan",
        top: 4,
        params: this.params
      }).then(res => {
        this.topNews = (res || []).map(item => {
          item.link =
            this.$subsitePrefix +
            `/ah/admission/detail/SchoolRecruitmentPlan?id=${item.Id}`;
          return item;
        });
      });
    },
    loadIndustryNews() {
      getData({
        name: "SchoolAdmissionInfo",
        top: 4,
        params: this.params
      }).then(res => {
        this.industryNews = (res || []).map(item => {
          item.link =
            this.$subsitePrefix +
            `/ah/admission/detail/SchoolAdmissionInfo?id=${item.Id}`;
          return item;
        });
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只允许png、jpg格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    onSubmit() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return;
        }
        var entity = {
          TableId: "RegisterSchool",
          Diploma: this.form.graduatedCertificate,
          GraduateSchool: this.form.graduatedSchool,
          IdentityCard: this.form.IDCard,
          Major: this.form.major,
          Phone: this.form.phone,
          RealName: this.form.realName,
          College: this.form.collegeName,
          // School: this.form.collegeName,
          SensusRegister: this.form.nativePlace,
          HomeAddress: this.form.address
        };
        createEntity(entity).then(res => {
          if (res.IsSuccess) {
            this.showModal = true;
            console.log("success");
          }
        });
        this.showModal = true;
      });
    },
    onReset() {
      this.diplomaFileList = [];
      this.icCardFileList = [];
      this.$refs["form"].resetFields();
    },
    init() {
      this.params = [
        {
          Key: "School",
          Value: this.collegeData.college.SchoolId,
          CompareType: "EqualTo"
        }
      ];
      this.loadSlideNews();
      this.loadTopNews();
      this.loadIndustryNews();
      this.majorList = this.collegeData.listMajor;
      getAllList({
        TableId: "College",
        School: this.collegeData.college.SchoolId
      }).then(res => {
        this.collegeList = res.Result;
      });
    },
    getCollegeLabel(val) {
      let obj = this.collegeList.find(item => {
        return item.Id === val;
      });
      this.realCollegeName = obj.Name;
    },
    getMajorLabel(val) {
      let obj = this.majorList.find(item => {
        return item.Id === val;
      });
      this.realMajor = obj.BaseMajor;
    },
    handleSuccess(response, file, fileList) {
      debugger;
      if (response.IsSuccess) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.form.graduatedCertificate = file.response.Result.fileId;
      } else {
        this.$message({
          type: "error",
          message: "导入失败"
        });
      }
    },
    finishClick() {
      this.showModal = false;
      this.$refs.form.resetFields();
    }
  },
  created() {
    this.init();
    this.form.collegeName = this.collegeData.college.Id
  }
};
</script>

<style lang="scss" scoped>
.page-home {
  .column-wrap {
    display: flex;
  }
  .news-wrap {
    display: flex;
    @include clearfix();
    padding-bottom: 40px;
    .news {
      margin-right: 24px;
    }
    .comp-slide-news {
      width: 376px;
      margin-right: 24px;
      height: 266px;
    }
    .comp-news {
      width: 376px;
      height: 266px;
    }
    .industry {
      width: 376px;
    }
  }
  .form-wrap {
    &::before {
      content: ' ';
      width: 100%;
      height: 400px;
      background: url(~assets/img/tp.png) no-repeat right top;
      position: absolute;
      right: 0;
      top: 0;
    }
    background: url(~assets/img/ft.png) no-repeat #f6f6f9 left bottom;
    position: relative;
    padding-bottom: 40px;
    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
      border-radius: 8px;
      padding: 40px;
      box-sizing: border-box;
      position: relative;
      .stat {
        position: absolute;
        right: 0;
        top: -40px;
        strong {
          color: #ff6010;
          font-size: 24px;
          font-weight: 500;
        }
      }
    }
    .form-row {
      display: flex;
      justify-content: space-between;
      .el-form-item {
        flex: 1;
      }
    }
    ::v-deep .el-input {
      width: 390px;
    }
    ::v-deep .el-upload__tip {
      margin-top: 0;
      line-height: 22px;
      color: #999;
      display: inline-block;
      padding-left: 10px;
    }
    .upload {
      .el-button {
        font-size: 14px;
      }
    }
    .btn-wrap {
      display: flex;
      margin: auto;
      width: 500px;
      justify-content: space-between;
      .el-button {
        flex: 1;
      }
    }
  }
  ::v-deep .comp-news--text {
    width: 376px;
  }
}
.dialog {
  ::v-deep .el-dialog {
    box-sizing: border-box;
    padding: 72px 100px 36px 100px;
    width: 785px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 10px 22px 0px rgba(69, 80, 238, 0.24);
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__header {
      display: none;
    }
    .icon {
      font-size: 64px;
      width: 64px;
      color: $primary-color;
      display: block;
      margin: 0 auto;
    }
    .text {
      font-size: 24px;
      font-weight: 600;
      line-height: 33px;
      text-align: center;
      font-weight: 500;
      color: #333;
    }
    .desc {
      text-align: center;
      font-size: 16px;
      line-height: 32px;
      padding: 16px 0 24px 0;
      strong {
        color: $primary-color;
        font-weight: 500;
      }
    }
  }
}
</style>
